import React from 'react';
import { motion } from 'framer-motion';
import { ExternalLink, Github } from 'lucide-react';

const Projects = () => {
  const projects = [
    {
      title: 'AI Document Analyzer',
      description:
        'Intelligent document analysis system using AI to extract, process, and analyze information from various document formats with high accuracy.',
      image: 'https://images.unsplash.com/photo-1697577418970-95d99b5a55cf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHxhcnRpZmljaWFsJTIwaW50ZWxsaWdlbmNlJTIwdGVjaG5vbG9neXxlbnwwfHx8fDE3NjE5MTIyMzJ8MA&ixlib=rb-4.1.0&q=85',
      technologies: ['Java', 'Spring Boot', 'AI/ML', 'REST API', 'MongoDB'],
      color: '#3b82f6',
      gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    },
    {
      title: 'Google Drive Clone',
      description:
        'Full-featured cloud storage solution with file upload, download, sharing, and folder management. Built with scalable microservices architecture.',
      image: 'https://images.unsplash.com/photo-1506399558188-acca6f8cbf41?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxjbG91ZCUyMHN0b3JhZ2V8ZW58MHx8fHwxNzYxOTEyMjUzfDA&ixlib=rb-4.1.0&q=85',
      technologies: ['Java', 'Spring Boot', 'AWS S3', 'MySQL', 'JWT'],
      color: '#10b981',
      gradient: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
    },
    {
      title: 'E-commerce Application',
      description:
        'Complete e-commerce backend with product catalog, cart management, order processing, payment integration, and user authentication.',
      image: 'https://images.unsplash.com/photo-1688561808434-886a6dd97b8c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHxlY29tbWVyY2UlMjBvbmxpbmUlMjBzaG9wcGluZyUyMHRlY2hub2xvZ3l8ZW58MHx8fHwxNzYxOTEyMjgyfDA&ixlib=rb-4.1.0&q=85',
      technologies: ['Java', 'Spring Boot', 'PostgreSQL', 'Redis', 'Stripe API'],
      color: '#f59e0b',
      gradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
    },
    {
      title: 'BookMyShow Backend',
      description:
        'Movie ticket booking system with theater management, seat selection, booking engine, and payment processing. Handles concurrent bookings efficiently.',
      image: 'https://images.unsplash.com/photo-1751823886813-0cfc86cb9478?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwzfHxtb3ZpZSUyMHRoZWF0ZXIlMjBib29raW5nJTIwdGVjaG5vbG9neXxlbnwwfHx8fDE3NjE5MTIzMTJ8MA&ixlib=rb-4.1.0&q=85',
      technologies: ['Java', 'Spring Boot', 'MySQL', 'JWT', 'Transactions'],
      color: '#ef4444',
      gradient: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
    },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6 },
    },
  };

  return (
    <section id="projects" className="projects-section">
      <div className="section-container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="section-title">Featured Projects</h2>
          <div className="title-underline"></div>
          <p className="section-subtitle">
            Building real-world applications with modern backend technologies
          </p>
        </motion.div>

        <motion.div
          className="projects-grid"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {projects.map((project, index) => (
            <motion.div
              key={index}
              className="project-card"
              variants={itemVariants}
              whileHover={{ y: -10, transition: { duration: 0.3 } }}
            >
              <div className="project-image-wrapper">
                <img
                  src={project.image}
                  alt={project.title}
                  className="project-image"
                />
                <div
                  className="project-overlay"
                  style={{ background: project.gradient }}
                ></div>
              </div>
              <div className="project-content">
                <h3 className="project-title">{project.title}</h3>
                <p className="project-description">{project.description}</p>
                <div className="project-technologies">
                  {project.technologies.map((tech, idx) => (
                    <span
                      key={idx}
                      className="tech-badge"
                      style={{ borderColor: project.color, color: project.color }}
                    >
                      {tech}
                    </span>
                  ))}
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Projects;